import { type ReactNode, useEffect } from 'react';

import { ThemeContext, type ThemeContextType } from '@/providers/themeContext';

const themeValue: ThemeContextType = {
  theme: 'light',
  setTheme: () => {},
  resolvedTheme: 'light',
};

/**
 * Light-locked theme provider (gpm pattern): forces the `.light` class +
 * `color-scheme: light` on `<html>` so gpm-ui tokens resolve consistently
 * regardless of OS preference. Swap the internals when dark mode ships;
 * consumers keep using `useTheme()`.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.add('light');
    root.style.colorScheme = 'light';
  }, []);

  return <ThemeContext.Provider value={themeValue}>{children}</ThemeContext.Provider>;
}
